<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">Many commit the same crime</p>
<p class="ded1">with a very different result.</p>
<p class="ded1">One bears a cross for his</p>
<p class="ded1">crime; another a crown.</p>
<p class="ded1">—Juvenal</p>
<p class="ded2">I am unjust, but I can strive for justice.</p>
<p class="ded1">My life’s unkind, but I can vote for kindness.</p>
<p class="ded1">I, the unloving, say life should be lovely.</p>
<p class="ded1">I, that am blind, cry out against my blindness.</p>
<p class="ded1">—Vachel Lindsay</p>
<p class="ded2">I know that what I do is wrong, but my reasons for doing it are right.</p>
<p class="ded1">I hate blood and killing, but I hate the Mafia cancer even more.</p>
<p class="ded1">—Mack Bolan, <i>The Executioner</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0e9bdcd6